'use client';

import CreateAccountDesktopRedirect from '@/components/CreateAccountPage/create-account-desktop-redirect';
import dynamic from 'next/dynamic';
import { Suspense } from 'react';

const CreateAccountPage = dynamic(() => import('@/components/CreateAccountPage'), { ssr: false });

const Page = () => {
  return (
    <>
      <div id='container'>
        <h1 className='hidden'>My account</h1>
        <CreateAccountPage />
      </div>
      <Suspense>
        <CreateAccountDesktopRedirect />
      </Suspense>
    </>
  );
};

export default Page;
